import { css } from '@emotion/react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

import pendingWorkspaceAccessImage from '../../../assets/pending-workspace-access.svg';

const rootStyle = css`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  min-height: calc(100vh - 60px);
  padding: 80px 20px 40px;

  @media (max-width: 900px) {
    padding: 60px 20px 40px;
  }
`;

const cardStyle = css`
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  padding: 0;
  max-width: 800px;
  width: 100%;

  @media (max-width: 900px) {
    max-width: 100%;
  }
`;

const contentContainerStyle = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 48px;
  padding: 32px 40px;

  @media (max-width: 900px) {
    flex-direction: column;
    gap: 32px;
    padding: 32px 24px;
  }
`;

const textContentStyle = css`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  max-width: 380px;

  @media (max-width: 900px) {
    max-width: 100%;
    text-align: center;
  }
`;

const titleStyle = css`
  font-size: 20px;
  font-weight: 600;
  line-height: 1.3;
  margin: 0;
  color: #2d2e2e;
`;

const descriptionStyle = css`
  font-size: 15px;
  line-height: 1.5;
  color: #5c5f62;
  margin: 0;
`;

const imageContainerStyle = css`
  width: 300px;
  height: 240px;
  flex-shrink: 0;
  position: relative;

  /* Column layout only: a % width avoids a min-content overflow at 320px (SC 1.4.10). */
  @media (max-width: 900px) {
    width: 100%;
    max-width: 280px;
    /* Keep: a fixed height with aspect-ratio brings the 320px overflow back. */
    height: auto;
    aspect-ratio: 5 / 4;
  }

  @media (max-width: 480px) {
    max-width: 240px;
  }
`;

export function PendingWorkspaceAccessPage() {
  const t = useTranslations('pending-workspace-access');

  return (
    <div css={rootStyle}>
      <div css={cardStyle}>
        <div css={contentContainerStyle}>
          <div css={textContentStyle}>
            <h1 css={titleStyle}>{t('heading')}</h1>
            <p css={descriptionStyle}>{t('description')}</p>
          </div>
          <div css={imageContainerStyle}>
            <Image
              src={pendingWorkspaceAccessImage}
              alt={t('image-alt')}
              fill
              style={{ objectFit: 'contain' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
